export default __webpack_public_path__ + "static/media/pintrest.807bd42f.svg";